<template>
  <Modal
    title="Log's da Integração com o Cilia"
    @close="closeModal()"
    :active.sync="showLocal"
  >
    <div
      v-for="item in list"
      :key="item.idLogIntegracaoCilia"
      class="integracao"
    >
      <div class="integracao__date">
        {{ formataData(item.createdAt) }}
      </div>
      <div class="integracao__evento">
        <vs-chip color="success" v-if="item.idEventoCilia">
          {{ item.idEventoCilia }}
        </vs-chip>
      </div>
      <div>
        {{ item.mensagem }}
      </div>
    </div>
  </Modal>
</template>

<script>
import moment from 'moment';
import Modal from '../../../../../components/Modal.vue';

export default {
  components: { Modal },
  props: ['show', 'list'],
  watch: {
    show(value) {
      this.showLocal = value;
    },
  },
  data() {
    return {
      showLocal: false,
    };
  },
  methods: {
    closeModal() {
      this.showLocal = false;
      this.$emit('update:show', false);
    },
    formataData(data) {
      if (!data) {
        return '';
      }

      return moment(data).format('DD/MM/YYYY HH:mm');
    },
  },
};
</script>

<style lang="scss" scoped>
.integracao {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  padding-bottom: 8px;

  &:not(:last-child) {
    border-bottom: 1px solid #ccc;
  }

  &__date {
    flex: 0 0 120px;
  }

  &__evento {
    flex: 0 0 100px;
  }
}
</style>
